module.exports = __webpack_public_path__ + "media/stylesheets/images/vision-85a765ecc6bd74718c2ef933681ba954.svg";